import Vue from 'vue';

import 'normalize.css';
import ElementUI from 'element-ui';
import SvgIcon from 'vue-svgicon';
import Fragment from 'vue-fragment';
import '@/styles/element-variables.scss';
import '@/styles/index.scss';

import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import '@/icons/components';
import '@/permission';
import { sync } from 'vuex-router-sync';

import LogUtils from 'panda-log';
import '@/filters';
import enterNumber from './utils/directives';

// @ts-ignore
ElementUI.Dialog.props.closeOnClickModal.default = false;
ElementUI.MessageBox.setDefaults({
  closeOnClickModal: false,
});
sync(store, router);

Vue.use(Fragment.Plugin);
Vue.use(ElementUI);
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em',
});

Vue.config.productionTip = false;
Vue.directive('enterNumber', enterNumber);
Vue.prototype.$log = LogUtils;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
